/**
 * Tracks which chat conversation the user is actively viewing so
 * notification toasts can be suppressed for that thread only
 * (Socket.IO already updates the open chat UI).
 */

let _activeConversationId = "";

export function setActiveChatConversationId(conversationId) {
  _activeConversationId = String(conversationId ?? "").trim();
}

export function clearActiveChatConversationId(conversationId) {
  const cid = String(conversationId ?? "").trim();
  if (!cid || _activeConversationId === cid) {
    _activeConversationId = "";
  }
}

export function getActiveChatConversationId() {
  return _activeConversationId;
}
